<template>
    <v-container>
        <v-row class="my-10">
            <v-col>
                <span class="text-tcdc-green header bold">Page Not found</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Notfound"
    }
</script>

<style scoped>

</style>
